export default {
  signInTitle: 'Welcome Back',
  signInSubtitle: 'Sign in to your account to continue',
  signUpTitle: 'Create Account',
  signUpSubtitle: 'Start your pet care journey',
  forgotPasswordTitle: 'Forgot Password',
  forgotPasswordSubtitle: 'Enter your email address and we\'ll send you a password reset link',
  resetPasswordTitle: 'Create New Password',
  resetPasswordSubtitle: 'Please enter your new password',
  
  emailPlaceholder: 'Email',
  passwordPlaceholder: 'Password',
  confirmPasswordPlaceholder: 'Confirm Password',
  newPasswordPlaceholder: 'New Password',
  confirmNewPasswordPlaceholder: 'Confirm New Password',
  
  signInButton: 'Sign In',
  signUpButton: 'Sign Up',
  sendResetEmailButton: 'Send Reset Email',
  updatePasswordButton: 'Update Password',
  continueWithGoogle: 'Continue with Google',
  orDivider: 'or',
  forgotPassword: 'Forgot password?',
  backToSignIn: 'Back to Sign In',
  
  noAccount: 'Don\'t have an account?',
  alreadyHaveAccount: 'Already have an account?',
  
  signingYouIn: 'Signing you in...',
  creatingAccount: 'Creating account...',
  sendingResetEmail: 'Sending email...',
  updatingPassword: 'Updating password...',
  
  signInSuccess: 'Sign in successful!',
  accountCreatedAndSignedIn: 'Account created successfully! Signing in...',
  resetEmailSent: 'Password reset email sent! Please check your inbox',
  passwordUpdatedSuccess: 'Password updated successfully! Redirecting to dashboard...',
  
  emailRequired: 'Please enter your email',
  emailInvalid: 'Invalid email format',
  passwordRequired: 'Please enter your password',
  passwordTooShort: 'Password must be at least 6 characters',
  confirmPasswordRequired: 'Please confirm your password',
  passwordMismatch: 'Passwords do not match',
  
  invalidLoginCredentials: 'Invalid email or password',
  userAlreadyRegistered: 'This email is already registered',
  emailNotConfirmed: 'Please confirm your email first',
  emailRateLimitExceeded: 'Too many requests, please try again later',
  securityRateLimit: 'For security purposes, you can only request this after 60 seconds',
  resetRequestCooldown: 'For security purposes, you can only request this after 15 seconds',
  userNotFound: 'User not found',
  samePasswordError: 'New password must be different from the old password',
  resetLinkExpired: 'Reset link has expired or is invalid',
  invalidResetLink: 'Invalid Reset Link',
  resetLinkExpiredMessage: 'This reset link has expired or has already been used. Please request a new password reset.',
  verifyingResetLink: 'Verifying reset link...',
  
  googleSignInError: 'Google sign-in failed, please try again later',
  unexpectedError: 'An unexpected error occurred, please try again later',
};